import { LazyImport, LazyModule } from 'owa-bundling';
import type { CoreOption, LazyOption } from '../store/schema/Option';
import type OptionComponentSettings from '../store/schema/OptionComponentSettings';
import type {
    default as OptionQuickComponentSettings,
    OptionQuickComponentSettingsWithKey,
} from '../store/schema/OptionQuickComponentSettings';

function createLazyOption<TFullModule, TQuickModule>(
    coreOption: CoreOption,
    fullOptionLazyModule?: LazyModule<TFullModule>,
    fullSettingsGetter?: (m: TFullModule) => OptionComponentSettings,
    quickOptionLazyModule?: LazyModule<TQuickModule>,
    quickOptionsGetter?: (
        m: TQuickModule
    ) => OptionQuickComponentSettings | OptionQuickComponentSettingsWithKey[]
): LazyOption {
    const fullLazyImport =
        fullOptionLazyModule && fullSettingsGetter
            ? new LazyImport(fullOptionLazyModule, fullSettingsGetter)
            : null;
    const quickLazyImport =
        quickOptionLazyModule && quickOptionsGetter
            ? new LazyImport(quickOptionLazyModule, quickOptionsGetter)
            : null;
    return {
        ...coreOption,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (31,9): Type '(() => OptionComponentSettings | undefined) | undefined' is not assignable to type '(() => OptionComponentSettings) | undefined'.
        // @ts-expect-error
        tryImportFullOptionFormSettingsSync: fullLazyImport
            ? () => fullLazyImport.tryImportForRender()
            : undefined,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (37,9): Type '(() => OptionQuickComponentSettings | OptionQuickComponentSettingsWithKey[] | undefined) | undefined' is not assignable to type '(() => OptionQuickComponentSettings | OptionQuickComponentSettingsWithKey[]) | undefined'.
        // @ts-expect-error
        tryImportQuickOptionSettingsSync: quickLazyImport
            ? () => quickLazyImport.tryImportForRender()
            : undefined,
    };
}

export { createLazyOption };
